import { FormEvent, useState } from "react";
import {
  Container,
  Description,
  Field,
  Input,
  Label,
  Status,
  SubmitButton,
  TextArea,
} from "./styles";

export default function NewChatSection() {
  const [status, setStatus] = useState<{ message: string; isError?: boolean }>({
    message: "",
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const apiBase = document.body.dataset.apiBase || "";

  const handleSubmit = async (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    const form = event.currentTarget;
    const formData = new FormData(form);
    const payload = {
      phone: formData.get("phone"),
      message: formData.get("message"),
    };

    if (!apiBase) {
      setStatus({ message: "לא הוגדר שרת לשליחת הודעות.", isError: true });
      return;
    }

    setIsSubmitting(true);
    setStatus({ message: "שולח הודעה..." });

    try {
      const response = await fetch(`${apiBase}/api/self-chat`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      });

      if (!response.ok) {
        throw new Error("Server error");
      }

      setStatus({ message: "ההודעה נשלחה. בדוק את הטלפון שלך." });
      form.reset();
    } catch (error) {
      setStatus({ message: "השליחה נכשלה. נסה שוב או בדוק את השרת.", isError: true });
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <Container>
      <Description>
        שלח לעצמך הודעה דרך השרת שלך. הבקשה תישלח לנתיב
        <code>/api/self-chat</code>.
      </Description>
      <form onSubmit={handleSubmit}>
        <Label>
          המספר שלך
          <Input name="phone" type="tel" placeholder="050-1234567" required />
        </Label>
        <Label>
          ההודעה
          <TextArea name="message" rows={4} placeholder="כתוב הודעה לעצמך" required />
        </Label>
        <Field>
          <SubmitButton type="submit" disabled={isSubmitting}>
            שלח
          </SubmitButton>
          <Status isError={status.isError}>{status.message}</Status>
        </Field>
      </form>
    </Container>
  );
}
